export default "__VITE_ASSET__Cmen5qaa__"